import { ALL_OPTION } from "constant";
import { useMemo } from "react";
import {
  useGetListBusiness,
  useGetListPbxType,
} from "service/query/business-management.query";

/**
 * Hook lọc nghiệp vụ theo loại tổng đài
 */
export const useListPbxTypeAndBusiness = (pbxType) => {
  const { data: listOrginPbxType } = useGetListPbxType();
  const { data: listOrginBusiness } = useGetListBusiness();

  const listFilteredBusiness = useMemo(() => {
    if (!listOrginBusiness) return [];
    if (pbxType === ALL_OPTION.value) return listOrginBusiness;
    return listOrginBusiness.filter((item) => item.pbxType === pbxType);
  }, [listOrginBusiness, pbxType]);

  return {
    listBusiness: listFilteredBusiness,
    listPbxType: listOrginPbxType,
  };
};
